import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "sign-in-page" }
const _hoisted_2 = { class: "sign-in-card" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "password-wrapper" }
const _hoisted_7 = ["type", "disabled"]
const _hoisted_8 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_9 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_10 = {
  key: 0,
  class: "error-message"
}
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("h1", { class: "sign-in-title" }, "Вход для администратора", -1)),
      _createElementVNode("form", {
        class: "sign-in-form",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _cache[4] || (_cache[4] = _createElementVNode("label", { for: "email" }, "Email", -1)),
          _withDirectives(_createElementVNode("input", {
            id: "email",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
            type: "email",
            placeholder: "admin@example.com",
            autocomplete: "email",
            disabled: _ctx.loading
          }, null, 8, _hoisted_4), [
            [_vModelText, _ctx.email]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[7] || (_cache[7] = _createElementVNode("label", { for: "password" }, "Пароль", -1)),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              id: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
              type: _ctx.showPassword ? 'text' : 'password',
              placeholder: "Введите пароль",
              autocomplete: "current-password",
              disabled: _ctx.loading
            }, null, 8, _hoisted_7), [
              [_vModelDynamic, _ctx.password]
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "eye-toggle",
              tabindex: "-1",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword))
            }, [
              (!_ctx.showPassword)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_8, [...(_cache[5] || (_cache[5] = [
                    _createElementVNode("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }, null, -1),
                    _createElementVNode("circle", {
                      cx: "12",
                      cy: "12",
                      r: "3"
                    }, null, -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("path", { d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" }, null, -1),
                    _createElementVNode("line", {
                      x1: "1",
                      y1: "1",
                      x2: "23",
                      y2: "23"
                    }, null, -1)
                  ]))]))
            ])
          ])
        ]),
        (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.errorMessage), 1))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "submit",
          class: "submit-btn",
          disabled: _ctx.loading
        }, _toDisplayString(_ctx.loading ? "Вход..." : "Войти"), 9, _hoisted_11)
      ], 32)
    ])
  ]))
}